var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("translates", {
    attrs: {
      item: this.item,
      item_id: parseInt(_vm.item.id),
      item_type: "pwa_group",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }